import React from 'react';
import { useTranslation } from 'react-i18next';
import iconNoLogin from 'Assets/layout/profile/attributes/no-login.svg';
import { POST_JOB_FLOW } from 'Douleutaras/views/job/post-job/types';

import { StartJobSectionProps } from './types';
import { CtaSectionContent } from './CtaSectionContent';

export const StartJobSection: React.FC<StartJobSectionProps> = ({ name, onPrimaryClicked, flow }) => {
  const { t } = useTranslation();
  let primaryTitle: string;
  let header = t('T.PROS-PROFILE.CTA.START-JOB-WITH');

  switch (true) {
    default:
      primaryTitle = t('T.PROS-PROFILE.CTA.Start a job together');
      break;
    case flow === POST_JOB_FLOW.SINGLE_BID:
      primaryTitle = t('T.PROS-PROFILE.CTA.Choose the pro');
      break;
    case flow === POST_JOB_FLOW.EXTRA_BID:
      header = t('T.PROS-PROFILE.CTA.BOOK-THIS-PRO');
      primaryTitle = t('T.PROS-PROFILE.CTA.SELECT-THE-PRO');
      break;
  }

  return (
    <CtaSectionContent icon={iconNoLogin}
                       header={header}
                       description={t('T.PROS-PROFILE.CTA.CHECK-PORTFOLIO-AND-START-JOB')}
                       primaryTitle={primaryTitle}
                       primaryAction={() => typeof onPrimaryClicked === 'function' && onPrimaryClicked()}
    />
  );
};
